import {
  SERVICE,
  dsFetch,
  handleCsrfError,
  handleInactiveUser,
  handleLicenseError,
  serviceProxy,
  servicesAuth,
  setCsrfOnHeader,
} from '@ds/swymkit/tools'
import type { BeforeErrorHook, HTTPError } from 'ky'

import type { SwymError, SwymErrorCode } from '~/interfaces/services-dto'

const handleErrorFormat: BeforeErrorHook = async (error) => {
  const { response } = error
  const isJson = response.headers.get('content-type')
    ?.includes('application/json')
  const data = isJson
    ? await response.clone()
      .json()
    : null

  if (data) {
    if (data.errorcode) {
      const err = error as SwymError

      err.errorcode = (`${data.errorcode}` as SwymErrorCode)
      err.errorid = `${data.errorid}`
      err.errormsg = `${data.errormsg}`

      return err as HTTPError
    }
    else {
      // @ts-expect-error Customizing of HTTPError by adding the data.
      error.data = data
    }
  }

  return error
}

/** Ky instance proxified on 3DSwym service */
export const swymFetch = dsFetch.extend({
  hooks: {
    beforeRequest: [
      setCsrfOnHeader(SERVICE.SWYM),
      serviceProxy(SERVICE.SWYM),
    ],
    afterResponse: [
      (...args) => handleCsrfError(SERVICE.SWYM, swymFetch)(...args),
      (...args) => servicesAuth(swymFetch, dsFetch)(...args),
    ],
    beforeError: [
      handleInactiveUser,
      handleLicenseError,
      handleErrorFormat,
    ],
  },
})

/** Ky instance proxified on 3DSwym service, without check to handle expired session */
export const swymFetchNoAuth = dsFetch.extend({
  hooks: {
    beforeRequest: [
      setCsrfOnHeader(SERVICE.SWYM),
      serviceProxy(SERVICE.SWYM),
    ],
    afterResponse: [
      (...args) => handleCsrfError(SERVICE.SWYM, swymFetch)(...args),
    ],
    beforeError: [
      handleInactiveUser,
      handleLicenseError,
      handleErrorFormat,
    ],
  },
})
